import { ContentItemStatus, SyncCoreDataDefinitionsEnumTranslator } from '@edgebox/sync-core-data-definitions';
import { faBoxArchive, faPenSquare, faSliders, faSpinner, faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

function getContentItemStatusPresentation(status?: ContentItemStatus):
  | {
      icon: typeof faSpinner;
      iconClassName: string;
      spin?: boolean;
      title: string;
    }
  | undefined {
  if (!status) {
    return undefined;
  }

  const title = SyncCoreDataDefinitionsEnumTranslator.transLateEnumValue('ContentItemStatus', status);

  switch (status) {
    case ContentItemStatus.Queued:
    case ContentItemStatus.Fetched:
    case ContentItemStatus.ProcessedStatically:
      return { icon: faSpinner, iconClassName: 'text-slate-500', spin: true, title };
    case ContentItemStatus.Draft:
      return { icon: faPenSquare, iconClassName: 'text-sky-500', title };
    case ContentItemStatus.Suggestion:
      return { icon: faSliders, iconClassName: 'text-violet-500', title };
    case ContentItemStatus.Published:
      return { icon: faCircleCheck, iconClassName: 'text-slate-800', title };
    case ContentItemStatus.PreviousRevision:
    case ContentItemStatus.Unpublished:
      return { icon: faBoxArchive, iconClassName: 'text-slate-500', title };
    default:
      return { icon: faSpinner, iconClassName: 'text-slate-500', spin: true, title };
  }
}

export function ContentItemStatusIcon({ status, className }: { status?: ContentItemStatus; className?: string }) {
  const presentation = getContentItemStatusPresentation(status);
  if (!presentation) {
    return null;
  }

  return (
    <span title={presentation.title} className="inline-flex items-center">
      <FontAwesomeIcon
        icon={presentation.icon}
        spin={presentation.spin}
        className={`${presentation.iconClassName} ${className || 'text-base'} ${presentation.spin ? 'animate-spin' : ''}`}
        style={presentation.spin ? { animationDuration: '1.8s' } : undefined}
      />
    </span>
  );
}
